// Build-time feature flags. CRA inlines REACT_APP_* at build, so changing one
// needs a redeploy. Set REACT_APP_HIDE_COMPARE=true on the production site only.
export function isCompareEnabled(env = process.env) {
  return (env.REACT_APP_HIDE_COMPARE || '').trim().toLowerCase() !== 'true';
}

export const COMPARE_ENABLED = isCompareEnabled();
